<script lang="ts">
  import { onMount, setContext } from 'svelte';
  import { sorterBasedOnAnotherArray } from '../../common/util';
  import { PREORDER_CONTENT_SLOT_ORDER } from '../common/lazy-components/driver/common-mapper';
  import LazyComponentLoader from '../common/lazy-components/driver/LazyComponentLoader.svelte';
  import { getCMSComponentsFromHybrisAsync } from '../common/services/hybris';

  export let pageConfig: any;
  setContext('direction', pageConfig?.direction);

  let preorderContentSlotInfo: string;
  let componentData;

  $: contentSlotToComponentUidsArray =
    preorderContentSlotInfo &&
    (preorderContentSlotInfo
      .substring(1, preorderContentSlotInfo.length - 2)
      .split('], ')
      .map(s => s.replace(/=\[/g, '='))
      .map(s => s.split('='))
      .map(([a, b]) => [a, b])
      .filter(([slotName]) => PREORDER_CONTENT_SLOT_ORDER.includes(slotName))
      .map(([slotName, compsString]) => [slotName, compsString.split(', ')])
      .sort(sorterBasedOnAnotherArray(PREORDER_CONTENT_SLOT_ORDER)) as [string, string[]][]);

  $: slotNameToGroupedUidsArray =
    contentSlotToComponentUidsArray &&
    contentSlotToComponentUidsArray.length > 0 &&
    groupSlots(contentSlotToComponentUidsArray, {});

  $: componentUids =
    slotNameToGroupedUidsArray && slotNameToGroupedUidsArray.map(([, componentUids]) => componentUids).flat();

  $: if (componentUids && componentUids.length > 0) {
    getCMSComponentsFromHybrisAsync(componentUids, true).then(data => (componentData = data));
  }

  $: componentDataMap =
    componentData &&
    componentData.component &&
    componentData.component
      .map(c => {
        return { [c.uid]: c };
      })
      .reduce((prev, curr) => Object.assign(prev, curr), {});

  function groupSlots(sortedSlots: [string, string[]][], slotGroups): [string, string[]][] {
    const output = [];
    const processedCombineIds = [];
    sortedSlots.forEach(sortedSlot => {
      const [slotname] = sortedSlot;
      if (slotname in slotGroups) {
        const combineId = slotGroups[slotname];
        if (processedCombineIds.indexOf(combineId) === -1) {
          // combine the slots
          const slotNamesWithCurrentCombineId = Object.keys(slotGroups).filter(x => slotGroups[x] === combineId);
          const combinedUids = sortedSlots
            .filter(x => slotNamesWithCurrentCombineId.indexOf(x[0]) > -1)
            .map(x => x[1])
            .flat();
          const combinedSlot = [slotname, combinedUids];
          output.push(combinedSlot);
          processedCombineIds.push(combineId);
        }
      } else {
        output.push(sortedSlot);
      }
    });
    return output;
  }

  onMount(() => {
    preorderContentSlotInfo = window.ACC?.config?.contentSlotInfo || null;
  });
</script>

<section class="c_preorder">
  {#if slotNameToGroupedUidsArray?.length > 0 && componentDataMap}
    {#each slotNameToGroupedUidsArray as [slotName, componentUids]}
      <LazyComponentLoader {slotName} {componentUids} componentsData={componentUids.map(c => componentDataMap[c])} />
    {/each}
  {/if}
</section>
